export default "__VITE_PUBLIC_ASSET__230603d1__"